import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AgGridAngular } from 'ag-grid-angular';
import { ColumnApi, GridApi } from 'ag-grid-community';
import * as moment from 'moment';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-new-field-visit',
  templateUrl: './new-field-visit.component.html',
  styleUrls: ['./new-field-visit.component.css']
})
export class NewFieldVisitComponent implements OnInit {
  private gridApi: GridApi;
  private columnApi: ColumnApi;
  @ViewChild('agGrid',{static:false}) agGrid: AgGridAngular;
  FieldVisitcolumnDefs = [
    {headerName: 'ID', field: '_id', width: 250, checkboxSelection: true,headerCheckboxSelection: true,sortable: true,sortingOrder: ['desc', 'asc'] , filter: true ,selectedNodes:true,addIndex:0,rowIndex:0},
    {headerName: 'Account ID', field: 'account_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Territory Name', field: 'fieldvisitarea', resizable: true, sortable: true, filter: true},
    {headerName: 'Area Name', field: 'fieldvisitterritory', resizable: true, sortable: true, filter: true},
    {headerName: 'TOS', field: 'total_out_standing', resizable: true, sortable: true, filter: true},
    {headerName: 'POS', field: 'pos', resizable: true, sortable: true, filter: true},
    {headerName: 'Product Name', field: 'product_type', resizable: true, sortable: true, filter: true},
    {headerName: 'First Address', field: 'firstaddress', resizable: true, sortable: true, filter: true},
    {headerName: 'Second Address', field: 'secondaddress', resizable: true, sortable: true, filter: true},
    {headerName: 'Requested Date', field: 'fvrqdate', resizable: true, sortable: true, filter: true},
    
    // {headerName: 'MOL Status', field: 'mol_status', resizable: true, sortable: true, filter: true},
    // {headerName: 'DED Status', field: 'ded_status', resizable: true, sortable: true, filter: true},
    // {headerName: 'UID Status', field: 'uid_status', resizable: true, sortable: true, filter: true},
    // {headerName: 'UID Number', field: 'uid_number', resizable: true, sortable: true, filter: true},
    {headerName: 'Remarks', field: 'remarks', resizable: true, sortable: true, filter: true},
    {headerName: 'Attachment URL', field: 'attachment_url', resizable: true, sortable: true, filter: true},
    {headerName: 'Status', field: 'status', resizable: true, sortable: true, filter: true},
    // {headerName: 'Created By', field: 'createdby', resizable: true, sortable: true, filter: true},
    {headerName: 'Creator Name', field: 'creator_name', resizable: true, sortable: true, filter: true},
    {headerName: 'Customer ID', field: 'customer_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Client ID', field: 'client_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Bank Name', field: 'bank_name', resizable: true, sortable: true, filter: true},
    // {headerName: 'Product ID', field: 'product_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Portfolio Name', field: 'portfolio_type', resizable: true, sortable: true, filter: true},
    // {headerName: 'Bucket ID', field: 'bucket_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Fintresle ID', field: 'finterstal_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Passport Number', field: 'passport_no', resizable: true, sortable: true, filter: true},
    {headerName: 'Created At', field: 'createdAt', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
      return moment(data.value).format('LLLL');
    }},
    {headerName: 'Update At', field: 'updatedAt', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
      return moment(data.value).format('LLLL');
    }},
    // {headerName: 'FV Done Date', field: 'FV_Done_Date', resizable: true, sortable: true, filter: true},
    // {headerName: 'Numbers Obtained', field: 'Numbers_Obtained', resizable: true, sortable: true, filter: true},
    // {headerName: 'FV Feedback', field: 'FV_Feedback', resizable: true, sortable: true, filter: true},
  ];
  
  FieldVisitForm: UntypedFormGroup;
  areaCodeList: any;
  bankCodeList: any;
  fieldvisitCodeList: any;
  mStatusList: any;
  sStatusList: any;
  FieldVisitList = [];
  login_Details: any;
  TracingToolsList: any;
  actionstakenList: any;
  uploaded: boolean;
  CoordinatorsList: any;
  coordinatorArea: any;
  coordinatorTRT: any;
  LinkedAccounts: any;
  selectedAcc: string;
  MarkCompleted_Status: boolean;

  check_allocation_status : any;
  createdId: any;
  fintId: any;
  customer_name: any;
  portfolio_type: any;
  bank_name: any;
  FV_Feedback: any;
  coordinator: any;
  gridColumnApi: any;
  product_type_list: any[];
  FieldVisitList1: any;
  pos: any;
  product_type: any;

  constructor(private formBuilder:UntypedFormBuilder, private _api:ApiService, @Inject(SESSION_STORAGE) private storage: StorageService) { 
    this.FieldVisitForm = this.formBuilder.group({
      _id:['',Validators.required],
      account_id:['',Validators.required],
      fieldvisitterritory:['',Validators.required],
      fieldvisitarea:['',Validators.required],
      firstaddress:['',Validators.required],
      secondaddress:[''],
      // labour_card:[''],
      // ded_number:[''],
      // mol_status:[''],
      // ded_status:[''],
      // uid_status:[''],
      // uid_number:[''],
      fvrqdate:['',Validators.required],
      remarks:['',Validators.required],
      reportingto_id:['',Validators.required],
      assigned_coordinator:['',Validators.required],
      assigned_agent:[''],
      approval_status :[''],
      attachment_url :[''],
      createdby:['',Validators.required],
      creator_name:['',Validators.required],
      status :['',Validators.required],
      customer_id:['',Validators.required],
      client_id :['',Validators.required],
      bank_id :['',Validators.required],
      product_id :['',Validators.required],
      portfolio_id :['',Validators.required],
      bucket_id :['',Validators.required],
      finterstal_id :['',Validators.required],
      passport_no :['',Validators.required]  ,
      bank_name : ['',Validators.required],
      portfolio_type : ['',Validators.required],
      customer_name : ['',Validators.required], 
      pos: ['',Validators.required],
      product_type: ['',Validators.required],
      
    })

  }
 
  onGridReady(params) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.gridColumnApi = params.columnApi;
  }
  // addRowToTop(row: any) {
  //   const currentData = this.gridApi.getRowData();
  //   const newData = [row, ...currentData];
  //   this.gridApi.updateRowData({ add: newData });
  // }
  
  onGetSelectedRowId() {
    const selectedNodes = this.gridApi.getSelectedNodes();
    if (selectedNodes.length > 0) {
      const selectedData = selectedNodes[0].data;
      this.createdId = selectedData.createdby;
      this.fintId = selectedData.finterstal_id;
      this.coordinator = selectedData.assigned_coordinator;
      this.customer_name = selectedData.Customer_Name;
      this.portfolio_type = selectedData.portfolio_type;
      this.bank_name = selectedData.bank_name;
      this.FV_Feedback = selectedData.FV_Feedback;
     
      console.log('createdId row ID:', selectedData);
    }
  }
  ngOnInit(): void {

    if (localStorage.getItem('MarkCompleted') == 'true') {
      this.MarkCompleted_Status = true;
    } else {
      this.MarkCompleted_Status = false;
    }
    this.coordinatorTRT = "";
    this.coordinatorArea = "";
    this._api.getlist_area_code().subscribe(data=>{
      if (data['Code'] == 200) {
        this.areaCodeList = data['Data'];
      } else {
        this.areaCodeList = [];
      }
    });
    this._api.getlist_bank_code().subscribe(data=>{
      if (data['Code'] == 200) {
        this.bankCodeList = data['Data'];
      } else {
        this.bankCodeList = [];
      }
    });
    this._api.getlist_fieldvisit_code().subscribe(data=>{
      if (data['Code'] == 200) {
        this.fieldvisitCodeList = data['Data'];
      } else {
        this.fieldvisitCodeList = [];
      }
    });
    let a = {
      client_id : this.getFromLocal("Client_ID")
    }
    this._api.product_type_list(a).subscribe(data=>{
      if (data['Code'] == 200) {
        this.product_type_list = data['Data'];
      } else {
        this.product_type_list = [];
      }
    });

    const LinkedData = {
      bucket_id: localStorage.getItem("Bucket_ID"),
      passport_no : localStorage.getItem("Passport_Number"),
    

    }
    this._api.getLinkedaccounts(LinkedData).subscribe(data=>{
      if (data['Code']==200) {
        this.LinkedAccounts = data['Data'];
       
        
      } else {
        this.LinkedAccounts = [];
      }
      console.log("this.LinkedAccounts ",this.LinkedAccounts );
    });


    let logindetail = this.getFromLocal("login_Details");
    // console.log(logindetail);
    let values = {
      "finterstal_id":localStorage.getItem("Fintrestle_ID"),
      "assigned_to":logindetail._id,
    }
    console.log(values);
    this._api.check_allocation_status(values).subscribe(data=>{
      if (data['Code']==200) {
        let check_allocation = data['Data'];
        console.log(check_allocation);
        if(check_allocation == null){
         this.check_allocation_status = false;
        }else{
          this.check_allocation_status = true;
        }
        console.log(this.check_allocation_status);
      } else {
      }
    });

    this.selectedAcc = localStorage.getItem("Account_ID");
//     this.portfolio_type = localStorage.getItem("portfolio_type", this.data),
// console.log("this.portfolio_type",this.portfolio_type);

    this.login_Details = this.getFromLocal("login_Details");
    this.FieldVisitForm.patchValue({
      createdby: this.login_Details._id,
      creator_name: this.login_Details.name,
      customer_id: localStorage.getItem("Fintrestle_ID"),
      account_id:localStorage.getItem("Account_ID"),
      client_id : localStorage.getItem("Client_ID"),
      bank_id : localStorage.getItem("Bank_ID"),
      product_id : localStorage.getItem("Product_ID"),
      portfolio_id : localStorage.getItem("Portfolio_ID"),
      bucket_id : localStorage.getItem("Bucket_ID"),
      finterstal_id : localStorage.getItem("Fintrestle_ID"),
      passport_no : localStorage.getItem("Passport_Number"),
      FintId : localStorage.getItem("Fintrestle_ID"),
      // bank_name : localStorage.getItem("bank_name"),
      // portfolio_type : localStorage.getItem("portfolio_type"),
      // customer_name : localStorage.getItem("customer_name"),
    });
    console.log("1234664",this.FieldVisitForm);
    this._api.getlist_new_fieldvisit(localStorage.getItem("Fintrestle_ID")).subscribe(data=>{
      if (data['Code']==200) {
        this.FieldVisitForm.patchValue({
          portfolio_type: data['Data'][0].portfolio_type,
          customer_name: data['Data'][0],
          bank_name : data['Data'][0].bank_name,
          
        });
        this.FieldVisitList = data['Data'];
        this.FieldVisitList.forEach(element => {
          let name = JSON.parse(element.customer_name.customer_details[0]);
          element.agent_name = name[0].AGENT;
          element.Customer_Name = name[0].Customer_Name;
          element.total_out_standing =  name && name[0][' total_out_standing '] ? name[0][' total_out_standing '] : '';
        });
       
       console.log("this.FieldVisitList1",this.FieldVisitList);
       
        
      } else {
        this.FieldVisitList = null;
      }
    });
    this._api.findReportTo(this.login_Details._id).subscribe(data=>{
      if (data['Code'] == 200) {
        this.FieldVisitForm.patchValue({
          reportingto_id: data['Data'].member_reporting_to_id
        });
       
      } else {
        this.FieldVisitForm.patchValue({
          reportingto_id: ""
        });
      }
    })
  }

  getFile(event){
    this.uploaded = false;
    const File = event.target.files[0];
    console.log(File);
    this._api.uploadFile(File).subscribe(data=>{
      if (data['Code'] = 200) {
        this.FieldVisitForm.patchValue({
          attachment_url:data['Data']
        })
        this.uploaded = true;
      } else {
        this.FieldVisitForm.patchValue({
          attachment_url:data['Data']
        })
        this.uploaded = false;
      }
    })
  }

  getFromLocal(key): any {
    return this.storage.get(key);
  }

  addNewFieldVisit(){
    if(this.check_allocation_status == false){
      alert("You don't have the access");   
      } else
      {
    this.FieldVisitForm.patchValue({
      _id:new Date().getTime(),
      log_date:new Date()
    });
    console.log("this.FieldVisitForm.value",this.FieldVisitForm.value);
    if(this.FieldVisitForm.value.reportingto_id == undefined){
      this.FieldVisitForm.value.reportingto_id = ''
    }
    
    // if (this.FieldVisitForm.valid) {
      
      this._api.create_new_fieldvisit(this.FieldVisitForm.value).subscribe(data=>{
        if (data['Code'] == 200) {
          
          this.onPagereload();
          
          // alert(data['Message']);
          this.sendNotification(this.FieldVisitForm.value);
          console.log("datadata",data);
          
        } else {
          alert(data['Message']);
        }
        this.FieldVisitForm.reset();
      });
    // } else {
    //   console.log(this.FieldVisitForm.value);
      
    //   alert('Form No Valid');
    // }
      }
  }

  ontrtchange(event){
    this.coordinatorTRT = event.target.value;
    // this.getCoordinatorsList(this.coordinatorArea,this.coordinatorTRT,"Field Visit Coordinator");
  }
  onareachange(event){
    this.coordinatorArea = event.target.value;
    this.getCoordinatorsList(this.coordinatorArea,this.coordinatorTRT,"Field Visit Coordinator");
  }

  getCoordinatorsList(area, territory, designation){
    const data = {
      fieldvisitterritory:territory,
      fieldvisitarea:area,
      designation:designation
    }
    this._api.getFieldVisitagents(data).subscribe(data=>{
      if (data['Code'] == 200) {
        this.CoordinatorsList = data['Data'];
        console.log("test.CoordinatorsList", this.CoordinatorsList);
        
        // if (this.CoordinatorsList.length = 1 && this.coordinatorArea != null && this.coordinatorTRT != null) {
        //   this.FieldVisitForm.patchValue({
        //     assigned_coordinator:this.CoordinatorsList[0]._id
        //   });
        // } else {
        //   this.FieldVisitForm.patchValue({
        //     assigned_coordinator:''
        //   });
        // }
      } else {
        this.CoordinatorsList = [];
      }
    });

  }

  sendNotification(data){
console.log("data1",data);

    const dataFormat = {
      from:  this.login_Details._id,
      to: data.assigned_coordinator,
      title: "New Notification",
      content: "You have recieved a Field Visit request",
      FintId: data.finterstal_id,
      bucket_id:data.bucket_id,
      Bank_Name: data.bank_name,
      Portfolio_Name: data.portfolio_type,
      Customer_Name:data.customer_name.Customer_Name,
      link : "/admin_panel/allocation/approval-request",
      read : false,
      status: true,
      view: true      
    }

    console.log("dataFormat",dataFormat);
    
    this._api.create_notifications(dataFormat).subscribe(data=>{
      if (data['Code'] == 200) {
        console.log("Sent",data);

      } else {
        console.log("Failed");
      }
    });
  }

  onPagereload(){
      this._api.getlist_new_fieldvisit(localStorage.getItem("Fintrestle_ID")).subscribe(data=>{
        if (data['Code']==200) {
          this.FieldVisitList = data['Data'];
          console.log("this.FieldVisitList",this.FieldVisitList);
          
        } else {
          this.FieldVisitList = null;
        }
      });
  }
}
